export enum TcRegion {
    HK = '香港',
    KLN = '九龍',
    NT = '新界',
}
